import React, { Component } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';

import { connect } from 'react-redux';

import { fetchProducts } from "reducers/product/productActions";

class ProductTypeahead extends Component {

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    constructor(props) {
        super(props);
        this.state = {
            allowNew: false,
            isLoading: false,
            multiple: false,
            useCache: false
        };
    }

    componentWillReceiveProps(nextProps) {
        console.log("componentWillReceiveProps", nextProps);
        /*if (nextProps.selection == null) {
            this.refs.syncTypeAhead.getInstance().clear();
        }*/
    }

    clearText() {
        this.refs.syncTypeAhead.getInstance().clear();
    }

    handleSearch = (query) => {

        console.log("handleSearch", query);

        this.setState({ isLoading: true });

        let promise = new Promise((resolve, reject) => {
            this.props.fetchProducts(this.props.projectId, query, resolve, reject);
        });
        promise.then(() => {
            this.setState({
                isLoading: false
            });
        });
    }

    handleChange(productSelected) {
        console.log("handleChange productSelected", productSelected, this.props.project);
        if (productSelected == undefined) {
            productSelected = null;
        } else {
            productSelected.projectName = this.props.project.label;
        }
        this.props.handleChange(productSelected);
    }

    render() {
        return (
            <AsyncTypeahead
                {...this.state}
                disabled={this.props.disabled}
                bsSize={"small"}
                ref="syncTypeAhead"
                options={this.props.products}
                labelKey="code"
                minLength={3}
                onSearch={this.handleSearch}
                placeholder="Busca un Lote"
                onChange={(selected) => this.handleChange(selected[0])}
                renderMenuItemChildren={(option, props) => (
                    <div key={option.id}> {option.code}  </div>
                )}
                selected={this.props.selection != null ? [this.props.selection] : null}
            />
        )
    }
}

const mapStateToProps = state => (
    {
        products: state.product.items
    }
)

export default connect(mapStateToProps, { fetchProducts })(ProductTypeahead)



// WEBPACK FOOTER //
// ./src/components/ProductTypeahead/ProductTypeahead.jsx